import { FC, useEffect } from "react";
import { getUserRole, KTSVG, ROLES } from "../../../../../../../_metronic/helpers";
import { useQueryResponse } from "../../../core/QueryResponseProvider";
import { useListView } from "../../../core/ListViewProvider";
import { useQueryClient } from "react-query";
import { MenuComponent } from "../../../../../../../_metronic/assets/ts/components";
import { FormattedMessage } from "react-intl";
import { Props } from "react-select";

const ActionCell: FC<Props> = ({ id }) => {
  const role = getUserRole();
  const { query } = useQueryResponse()
  const { itemIdForUpdate, setItemIdForUpdate } = useListView()
  const queryClient = useQueryClient()

  useEffect(() => {
    MenuComponent.reinitialization()
  }, [])

  const handleUpdate = () => {
    setItemIdForUpdate(id as string)
  }

  return (
    <>
      <a
        href='#'
        className='btn btn-light btn-active-light-primary btn-sm'
        data-kt-menu-trigger='click'
        data-kt-menu-placement='bottom-end'
      >
        {<FormattedMessage id="ACTIONS" />}
        <KTSVG path='/media/icons/duotune/arrows/arr072.svg' className='svg-icon-5 m-0' />
      </a>
      <div
        className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg-light-primary fw-bold fs-7 w-125px py-4'
        data-kt-menu='true'
      >
        {/* begin::Menu item */}
        {
          <div className='menu-item px-3'>
            <a
              className='menu-link px-3'
              data-kt-users-table-filter='update_row'
              onClick={handleUpdate}
            >
              {<FormattedMessage id='UPDATE' />}
            </a>
          </div>
        }

        {/* end::Menu item */}
      </div>
    </>
  )
}

export { ActionCell }